// ============================================================
//  ALTIMO Medical Center — Facturacion.jsx  (v2.2)
//  Fix: botones reordenados — Vista previa primero, Guardar PDF segundo
// ============================================================

import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../apiClient';

const S = {
  pagina:{ background:'#f0f4f8', minHeight:'100vh', padding:'20px', fontFamily:'Segoe UI, sans-serif' },
  card:  { background:'#fff', borderRadius:'10px', border:'1px solid #dde3ea', padding:'18px', marginBottom:'16px' },
  cardTitulo:{ fontSize:'12px', fontWeight:'700', color:'#1B2A5E', textTransform:'uppercase', letterSpacing:'.05em', marginBottom:'14px', paddingBottom:'10px', borderBottom:'2px solid #e8f0fb', display:'flex', justifyContent:'space-between', alignItems:'center' },
  input: { width:'100%', fontSize:'13px', padding:'8px 10px', border:'1px solid #c0ccda', borderRadius:'7px', background:'#fff', color:'#333', outline:'none', boxSizing:'border-box' },
  label: { display:'block', fontSize:'11px', fontWeight:'600', color:'#6c757d', marginBottom:'4px', textTransform:'uppercase', letterSpacing:'.04em' },
  campo: { marginBottom:'12px' },
  fila3: { display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'14px' },
  totalRow:  { display:'flex', justifyContent:'space-between', padding:'7px 0', fontSize:'13px', color:'#333' },
  totalFinal:{ display:'flex', justifyContent:'space-between', padding:'12px 0', fontSize:'18px', fontWeight:'800', color:'#1B2A5E', borderTop:'2px solid #1B2A5E', marginTop:'6px' },
  btnPrimario:  { background:'#1D9E75', color:'#fff', border:'none', borderRadius:'7px', padding:'10px 22px', fontSize:'13px', fontWeight:'700', cursor:'pointer' },
  btnAzul:      { background:'#1B2A5E', color:'#fff', border:'none', borderRadius:'7px', padding:'10px 22px', fontSize:'13px', fontWeight:'700', cursor:'pointer' },
  btnSecundario:{ background:'#fff', color:'#495057', border:'1px solid #c0ccda', borderRadius:'7px', padding:'9px 16px', fontSize:'12px', cursor:'pointer' },
  alerta:(tipo)=>({
    padding:'12px 16px', borderRadius:'8px', fontSize:'13px', fontWeight:'500', marginBottom:'14px',
    background:tipo==='ok'?'#d4edda':tipo==='err'?'#f8d7da':'#fff3cd',
    color:tipo==='ok'?'#155724':tipo==='err'?'#721c24':'#856404',
    border:`1px solid ${tipo==='ok'?'#c3e6cb':tipo==='err'?'#f5c6cb':'#ffc107'}`,
  }),
  exito:  { textAlign:'center', padding:'40px 20px' },
  exitoNum:{ fontSize:'32px', fontWeight:'800', color:'#1D9E75', marginBottom:'8px' },
  pdfBox: { background:'#e8f0fb', borderRadius:'10px', padding:'14px 18px', marginTop:'18px', display:'flex', alignItems:'center', gap:'12px', border:'1px solid #c8ddf7' },
};

function generarHTMLFactura(admision, factura, items, paraPdf = false) {
  const filas = items.map(i => `
    <tr>
      <td>${i.tipo}</td><td>${i.descripcion}</td>
      <td style="text-align:center">${i.cantidad}</td>
      <td style="text-align:right">$${Number(i.precio_unitario).toFixed(2)}</td>
      <td style="text-align:right"><strong>$${Number(i.total).toFixed(2)}</strong></td>
    </tr>`).join('');

  return `<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8"/>
<title>Factura ${factura.numero}</title>
<style>
  body{font-family:'Segoe UI',sans-serif;color:#222;margin:0;padding:0}
  .page{max-width:760px;margin:0 auto;padding:32px}
  .header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:28px}
  .logo-text{font-size:26px;font-weight:800;color:#1B2A5E;letter-spacing:.5px}
  .logo-sub{font-size:11px;letter-spacing:2px;color:#1D9E75;margin-top:2px}
  .factura-num{text-align:right}.factura-num h2{font-size:18px;color:#1B2A5E;margin:0 0 4px}
  .factura-num p{font-size:12px;color:#6c757d;margin:0}
  .divider{border:none;border-top:2px solid #1B2A5E;margin:0 0 20px}
  .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:24px;font-size:13px}
  .info-box{background:#f8fafd;border-radius:8px;padding:12px 16px}
  .info-label{font-size:10px;font-weight:700;color:#6c757d;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px}
  table{width:100%;border-collapse:collapse;font-size:12px;margin-bottom:20px}
  thead tr{background:#1B2A5E;color:#fff}
  thead th{padding:9px 10px;text-align:left;font-weight:600;font-size:11px}
  tbody tr:nth-child(even){background:#f8fafd}
  tbody td{padding:8px 10px;border-bottom:1px solid #eef1f6}
  .totales{max-width:300px;margin-left:auto;font-size:13px}
  .tot-row{display:flex;justify-content:space-between;padding:5px 0;color:#555}
  .tot-final{display:flex;justify-content:space-between;padding:10px 0;font-size:17px;font-weight:800;color:#1B2A5E;border-top:2px solid #1B2A5E;margin-top:4px}
  .pago-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin:20px 0;font-size:12px}
  .pago-box{background:#f0f4f8;border-radius:7px;padding:10px 14px;text-align:center}
  .pago-label{font-size:10px;color:#6c757d;font-weight:700;text-transform:uppercase;margin-bottom:4px}
  .pago-val{font-size:16px;font-weight:800;color:#1B2A5E}
  .footer{margin-top:32px;text-align:center;font-size:11px;color:#adb5bd;border-top:1px solid #eef1f6;padding-top:16px}
  @media print{.page{padding:16px}}
</style></head><body>
<div class="page">
  <div class="header">
    <div><div class="logo-text">ALTIMO</div><div class="logo-sub">MEDICAL CENTER</div>
    <div style="font-size:11px;color:#6c757d;margin-top:6px">NIT: 0614-000000-000-0</div></div>
    <div class="factura-num">
      <h2>${factura.numero}</h2>
      <p>Emitida: ${new Date(factura.emitida_en).toLocaleDateString('es-SV')}</p>
      <p style="margin-top:4px;background:#d4edda;color:#155724;padding:3px 10px;border-radius:99px;font-weight:700;font-size:11px;display:inline-block">${factura.estado}</p>
    </div>
  </div>
  <hr class="divider"/>
  <div class="info-grid">
    <div class="info-box">
      <div class="info-label">Paciente</div>
      <div style="font-weight:700;font-size:14px">${admision.paciente}</div>
      <div style="color:#6c757d;margin-top:2px">Expediente #${admision.id}</div>
    </div>
    <div class="info-box">
      <div class="info-label">Atención</div>
      <div>${admision.tipo_ingreso}</div>
      <div style="color:#6c757d">${admision.habitacion_num?`Hab. ${admision.habitacion_num} · ${admision.habitacion_tipo}`:'Ambulatorio'} · ${admision.dias} día(s)</div>
      <div style="color:#6c757d">Ingreso: ${new Date(admision.fecha_ingreso).toLocaleDateString('es-SV')}</div>
    </div>
  </div>
  <table><thead><tr><th>Tipo</th><th>Descripción</th><th style="text-align:center">Cant.</th><th style="text-align:right">P. Unit.</th><th style="text-align:right">Total</th></tr></thead>
  <tbody>${filas}</tbody></table>
  <div class="totales">
    <div class="tot-row"><span>Subtotal</span><span>$${Number(factura.subtotal).toFixed(2)}</span></div>
    <div class="tot-row"><span>IVA (${factura.iva_porcentaje}%)</span><span>$${Number(factura.iva_monto).toFixed(2)}</span></div>
    <div class="tot-final"><span>TOTAL</span><span>$${Number(factura.total).toFixed(2)}</span></div>
  </div>
  <div class="pago-grid">
    <div class="pago-box"><div class="pago-label">Seguro</div><div class="pago-val">$${Number(factura.seguro_monto).toFixed(2)}</div></div>
    <div class="pago-box"><div class="pago-label">Copago</div><div class="pago-val">$${Number(factura.copago).toFixed(2)}</div></div>
    <div class="pago-box"><div class="pago-label">Forma de pago</div><div class="pago-val" style="font-size:13px">${factura.forma_pago||'Efectivo'}</div></div>
  </div>
  <div class="footer">ALTIMO Medical Center · Gracias por su confianza<br/>Este documento es válido como comprobante de pago</div>
</div>
${paraPdf?'':'<script>window.onload=()=>window.print();<\/script>'}
</body></html>`;
}

export default function Facturacion({ usuario, admisionId: propAdmisionId }) {
  const [busAdmision,    setBusAdmision]    = useState('');
  const [textoBusq,      setTextoBusq]      = useState('');
  const [resultsBusq,    setResultsBusq]    = useState([]);
  const [buscandoTexto,  setBuscandoTexto]  = useState(false);
  const [admisionId,     setAdmisionId]     = useState(propAdmisionId || null);
  const [admision,       setAdmision]       = useState(null);
  const [items,          setItems]          = useState([]);
  const [totales,        setTotales]        = useState({ subtotal:0, iva:0, total:0 });
  const [seguroMonto,    setSeguroMonto]    = useState('0');
  const [formaPago,      setFormaPago]      = useState('Efectivo');
  const [cargando,       setCargando]       = useState(false);
  const [emitiendo,      setEmitiendo]      = useState(false);
  const [guardandoPdf,   setGuardandoPdf]   = useState(false);
  const [mensaje,        setMensaje]        = useState(null);
  const [facturaEmitida, setFacturaEmitida] = useState(null);
  const [rutaGuardada,   setRutaGuardada]   = useState(null);
  const inputBusqRef = useRef(null);

  const cargarDatos = useCallback(async (id) => {
    if (!id) return;
    setCargando(true);
    const [rAdm, rItems, rTotal] = await Promise.all([
      api.admisiones.obtener(id),
      api.cuenta.items(id),
      api.cuenta.total(id),
    ]);
    if (rAdm.ok)   setAdmision(rAdm.data);
    if (rItems.ok) setItems(rItems.data);
    if (rTotal.ok) setTotales(rTotal.data);
    setCargando(false);
  }, []);

  useEffect(() => { if (admisionId) cargarDatos(admisionId); }, [admisionId, cargarDatos]);

  // Fuerza el foco en el buscador al mostrarse. Esto corrige un problema de
  // Electron/Chromium donde, tras cerrar un diálogo nativo (window.confirm
  // al cerrar la cuenta en "Cuenta del paciente"), el foco del documento
  // queda en un estado inconsistente y el primer intento de escribir aquí
  // no responde hasta hacer clic manualmente.
  useEffect(() => {
    if (!admisionId && inputBusqRef.current) {
      const t = setTimeout(() => inputBusqRef.current?.focus(), 50);
      return () => clearTimeout(t);
    }
  }, [admisionId]);

  // Búsqueda en tiempo real por nombre / DUI
  useEffect(() => {
    if (textoBusq.length < 2) { setResultsBusq([]); return; }
    const t = setTimeout(async () => {
      setBuscandoTexto(true);
      const r = await api.admisiones.buscar(textoBusq);
      setBuscandoTexto(false);
      if (r.ok) setResultsBusq(r.data || []);
    }, 350);
    return () => clearTimeout(t);
  }, [textoBusq]);

  const buscarAdmision = () => {
    const id = parseInt(busAdmision);
    if (isNaN(id)) { setMensaje({ tipo:'err', texto:'Número de expediente inválido.' }); return; }
    setResultsBusq([]); setTextoBusq('');
    setAdmisionId(id);
  };

  const seguro = Math.max(0, parseFloat(seguroMonto) || 0);
  const copago = Math.max(0, totales.total - seguro);

  const emitirFactura = async () => {
    if (!admision) return;
    if (items.length === 0) { setMensaje({ tipo:'warn', texto:'No hay ítems en la cuenta para facturar.' }); return; }
    setEmitiendo(true); setMensaje(null);
    const r = await api.facturas.generar({
      admision_id: admisionId, seguro_monto: seguro, forma_pago: formaPago, usuario_id: usuario.id,
    });
    setEmitiendo(false);
    if (!r.ok) { setMensaje({ tipo:'err', texto: r.error }); return; }
    const rFac = await api.facturas.obtener(admisionId);
    if (rFac.ok) setFacturaEmitida(rFac.data);
    setMensaje({ tipo:'ok', texto:`✓ Factura ${r.data} emitida. Revisa la vista previa antes de guardar.` });
  };

  // Vista previa — abre ventana del navegador SIN auto-print
  const verVistaPrevia = () => {
    if (!facturaEmitida || !admision) return;
    const html = generarHTMLFactura(admision, facturaEmitida, items, false);
    const win  = window.open('', '_blank', 'width=800,height=700');
    win.document.write(html);
    win.document.close();
  };

  // Guardar PDF en carpeta del paciente
  const guardarEnExpediente = async () => {
    if (!facturaEmitida || !admision) return;
    setGuardandoPdf(true); setMensaje(null);
    try {
      const html = generarHTMLFactura(admision, facturaEmitida, items, true);
      const r = await api.facturas.guardarPdfDisco({ admision_id: admisionId, html });
      if (r.ok) {
        setRutaGuardada(r.data?.filePath || '');
        setMensaje({ tipo:'ok', texto:`✓ Factura guardada: ${r.data?.carpeta || ''}` });
      } else {
        setMensaje({ tipo:'err', texto: r.error });
      }
    } catch (e) { setMensaje({ tipo:'err', texto: e.message }); }
    setGuardandoPdf(false);
  };

  const resetear = () => {
    setFacturaEmitida(null); setAdmision(null); setAdmisionId(null);
    setItems([]); setBusAdmision(''); setMensaje(null); setTextoBusq('');
    setResultsBusq([]); setRutaGuardada(null); setSeguroMonto('0');
  };

  // ── Vista: factura emitida ──
  if (facturaEmitida) {
    return (
      <div style={{ fontFamily:'Segoe UI, sans-serif' }}>
        <div style={{ background:'linear-gradient(135deg,#1B2A5E,#0f1c40)', padding:'16px 24px' }}>
          <div style={{ fontSize:'19px', fontWeight:'800', color:'#fff', marginBottom:'3px' }}>
            💵 Módulo de Facturación
          </div>
          <div style={{ fontSize:'12px', color:'rgba(255,255,255,.8)' }}>
            Emisión de facturas · Copagos · Seguros
          </div>
        </div>
        <div style={S.pagina}>
        {mensaje && <div style={S.alerta(mensaje.tipo)}>{mensaje.texto}</div>}
        <div style={S.card}>
          <div style={S.exito}>
            <div style={S.exitoNum}>{facturaEmitida.numero}</div>
            <p style={{ color:'#6c757d', marginBottom:'28px', fontSize:'14px' }}>
              Factura emitida para <strong>{admision?.paciente}</strong>
            </p>

            {/* Resumen */}
            <div style={{ maxWidth:'360px', margin:'0 auto 28px', textAlign:'left', background:'#f8fafd', borderRadius:'10px', padding:'16px 20px', border:'1px solid #dde3ea' }}>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>Subtotal</span><span>${Number(facturaEmitida.subtotal).toFixed(2)}</span></div>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>IVA 13%</span><span>${Number(facturaEmitida.iva_monto).toFixed(2)}</span></div>
              <div style={{ ...S.totalFinal,fontSize:'16px' }}><span>Total</span><span>${Number(facturaEmitida.total).toFixed(2)}</span></div>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>Seguro</span><span style={{ color:'#1D9E75' }}>- ${Number(facturaEmitida.seguro_monto).toFixed(2)}</span></div>
              <div style={{ ...S.totalRow,fontWeight:'700',fontSize:'15px',color:'#dc3545' }}>
                <span>Copago paciente</span><span>${Number(facturaEmitida.copago).toFixed(2)}</span>
              </div>
            </div>

            {/* BOTONES: Vista previa PRIMERO, Guardar PDF EN MEDIO, Nueva factura al final */}
            <div style={{ display:'flex', justifyContent:'center', gap:'12px', flexWrap:'wrap' }}>
              {/* 1. Vista previa */}
              <button style={S.btnAzul} onClick={verVistaPrevia}>
                👁 Vista previa
              </button>
              {/* 2. Guardar PDF en expediente */}
              <button style={S.btnPrimario} onClick={guardarEnExpediente} disabled={guardandoPdf}>
                {guardandoPdf ? '⏳ Guardando...' : '💾 Guardar PDF en expediente'}
              </button>
              {/* 3. Nueva factura */}
              <button style={S.btnSecundario} onClick={resetear}>Nueva factura</button>
            </div>

            {/* Confirmación ruta */}
            {rutaGuardada && (
              <div style={S.pdfBox}>
                <span style={{ fontSize:'24px' }}>📁</span>
                <div style={{ textAlign:'left' }}>
                  <div style={{ fontSize:'12px',fontWeight:'700',color:'#1B2A5E',marginBottom:'2px' }}>PDF guardado en el expediente del paciente</div>
                  <div style={{ fontSize:'11px',color:'#6c757d',wordBreak:'break-all' }}>{rutaGuardada}</div>
                  <div style={{ fontSize:'11px',color:'#1D9E75',marginTop:'4px' }}>La carpeta se abrió en el explorador de archivos.</div>
                </div>
              </div>
            )}
          </div>
        </div>
        </div>
      </div>
    );
  }

  // ── Vista: formulario ──
  return (
    <div style={{ fontFamily:'Segoe UI, sans-serif' }}>
      <div style={{ background:'linear-gradient(135deg,#1B2A5E,#0f1c40)', padding:'16px 24px' }}>
        <div style={{ fontSize:'19px', fontWeight:'800', color:'#fff', marginBottom:'3px' }}>
          💵 Módulo de Facturación
        </div>
        <div style={{ fontSize:'12px', color:'rgba(255,255,255,.8)' }}>
          Emisión de facturas · Copagos · Seguros
        </div>
      </div>
      <div style={S.pagina}>
      {!admisionId && (
        <div style={S.card}>
          <div style={S.cardTitulo}>Buscar expediente a facturar</div>

          {/* Búsqueda por nombre o DUI */}
          <div style={{ marginBottom:'12px' }}>
            <label style={S.label}>🔍 Buscar por nombre del paciente o DUI</label>
            <div style={{ position:'relative' }}>
              <input style={{ ...S.input, paddingRight:'100px' }}
                ref={inputBusqRef}
                placeholder="Escribe nombre, apellido o DUI..."
                value={textoBusq}
                onChange={e => { setTextoBusq(e.target.value); setMensaje(null); }}
              />
              {buscandoTexto && (
                <span style={{ position:'absolute', right:'10px', top:'50%', transform:'translateY(-50%)', fontSize:'11px', color:'#6c757d' }}>
                  Buscando...
                </span>
              )}
            </div>
            {resultsBusq.length > 0 && (
              <div style={{ border:'1px solid #dde3ea', borderRadius:'8px', marginTop:'4px', maxHeight:'240px', overflowY:'auto', background:'#fff', boxShadow:'0 4px 20px rgba(0,0,0,.12)' }}>
                {resultsBusq.map(a => (
                  <div key={a.id}
                    style={{ padding:'10px 14px', cursor:'pointer', fontSize:'13px', borderBottom:'1px solid #f0f4f8', display:'flex', justifyContent:'space-between', alignItems:'center' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f4f8'}
                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                    onClick={() => {
                      setTextoBusq(''); setResultsBusq([]);
                      setAdmisionId(a.id);
                    }}>
                    <div>
                      <strong style={{ color:'#1B2A5E' }}>{a.paciente}</strong>
                      <span style={{ color:'#6c757d', fontSize:'11px', marginLeft:'8px' }}>
                        {a.dui ? `DUI: ${a.dui}` : 'Sin DUI'} · {a.telefono || '—'}
                      </span>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize:'12px', fontWeight:'700', color:'#1B2A5E' }}>Exp.#{a.id}</div>
                      <div style={{ fontSize:'10px', color:'#6c757d' }}>{a.tipo_ingreso || '—'} · {a.estado}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Separador */}
          <div style={{ display:'flex', alignItems:'center', gap:'10px', margin:'10px 0', color:'#adb5bd', fontSize:'11px' }}>
            <div style={{ flex:1, borderTop:'1px solid #e8f0fb' }} />
            O ingresar número de expediente directamente
            <div style={{ flex:1, borderTop:'1px solid #e8f0fb' }} />
          </div>

          {/* Búsqueda por número de expediente */}
          <div style={{ display:'flex', gap:'10px' }}>
            <input style={{ ...S.input, flex:1 }} type="number"
              placeholder="Número de expediente / admisión..."
              value={busAdmision} onChange={e => setBusAdmision(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && buscarAdmision()} />
            <button style={S.btnAzul} onClick={buscarAdmision}>Buscar</button>
          </div>
        </div>
      )}
      {mensaje && <div style={S.alerta(mensaje.tipo)}>{mensaje.texto}</div>}
      {cargando && <div style={{ textAlign:'center',padding:'40px',color:'#6c757d' }}>Cargando datos...</div>}

      {admision && !cargando && (
        <>
          <div style={S.card}>
            <div style={S.cardTitulo}>
              <span>Expediente #{admision.id} — {admision.paciente}</span>
              <button style={S.btnSecundario} onClick={()=>{ setAdmisionId(null); setAdmision(null); setBusAdmision(''); }}>Cambiar</button>
            </div>
            <div style={{ display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'14px',fontSize:'13px' }}>
              {[['TIPO INGRESO',admision.tipo_ingreso],['HABITACIÓN',admision.habitacion_num?`${admision.habitacion_num} · ${admision.habitacion_tipo}`:'Ambulatorio'],['MÉDICO',admision.medico_nombre||'—'],['DÍAS',admision.dias],['ESTADO CUENTA',admision.estado_cuenta||'Activa']].map(([l,v])=>(
                <div key={l}><div style={{ color:'#6c757d',fontSize:'11px',marginBottom:'3px' }}>{l}</div>
                  <strong style={l==='ESTADO CUENTA' ? { color: v==='Cerrada' ? '#1D9E75' : '#dc3545' } : {}}>{v}</strong>
                </div>
              ))}
            </div>
            {admision.estado_cuenta !== 'Cerrada' && (
              <div style={{ marginTop:'12px', padding:'10px 14px', background:'#fff3cd', borderRadius:'7px', fontSize:'12px', color:'#856404', fontWeight:'600' }}>
                ⚠️ Esta cuenta aún no ha sido cerrada por caja. Ve a "Cuenta del paciente" y usa el botón "🔒 Cerrar cuenta" antes de poder facturar — eso consolida todos los cargos (habitación, medicina, exámenes, honorarios, insumos) en el monto final.
              </div>
            )}
          </div>

          <div style={S.card}>
            <div style={S.cardTitulo}>Detalle de cargos ({items.length} ítems)</div>
            <table style={{ width:'100%',borderCollapse:'collapse',fontSize:'13px' }}>
              <thead><tr>{['Tipo','Descripción','Cant.','P. Unit.','Total'].map(h=>(
                <th key={h} style={{ textAlign:'left',padding:'8px 10px',fontSize:'11px',color:'#6c757d',fontWeight:'600',borderBottom:'2px solid #e8f0fb',background:'#f8fafd' }}>{h}</th>
              ))}</tr></thead>
              <tbody>
                {items.map((item,i)=>(
                  <tr key={i} onMouseEnter={e=>e.currentTarget.style.background='#f8fafd'} onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <td style={{ padding:'8px 10px',borderBottom:'1px solid #eef1f6',fontSize:'11px',color:'#6c757d' }}>{item.tipo}</td>
                    <td style={{ padding:'8px 10px',borderBottom:'1px solid #eef1f6' }}>{item.descripcion}</td>
                    <td style={{ padding:'8px 10px',borderBottom:'1px solid #eef1f6' }}>{item.cantidad}</td>
                    <td style={{ padding:'8px 10px',borderBottom:'1px solid #eef1f6' }}>${Number(item.precio_unitario).toFixed(2)}</td>
                    <td style={{ padding:'8px 10px',borderBottom:'1px solid #eef1f6',fontWeight:'700',color:'#1B2A5E' }}>${Number(item.total).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:'16px' }}>
            <div style={S.card}>
              <div style={S.cardTitulo}>División de pago</div>
              <div style={S.fila3}>
                <div style={S.campo}>
                  <label style={S.label}>Monto seguro ($)</label>
                  <input style={S.input} type="number" min="0" step="0.01" value={seguroMonto} onChange={e=>setSeguroMonto(e.target.value)} />
                </div>
                <div style={S.campo}>
                  <label style={S.label}>Copago paciente</label>
                  <div style={{ ...S.input,background:'#f8fafd',color:copago>0?'#dc3545':'#1D9E75',fontWeight:'700' }}>${copago.toFixed(2)}</div>
                </div>
                <div style={S.campo}>
                  <label style={S.label}>Forma de pago</label>
                  <select style={S.input} value={formaPago} onChange={e=>setFormaPago(e.target.value)}>
                    <option value="Efectivo">Efectivo</option>
                    <option value="Tarjeta">Tarjeta</option>
                    <option value="Transferencia">Transferencia</option>
                    <option value="Seguro">Seguro directo</option>
                  </select>
                </div>
              </div>
            </div>
            <div style={S.card}>
              <div style={S.cardTitulo}>Resumen final</div>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>Subtotal</span><span>${totales.subtotal.toFixed(2)}</span></div>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>IVA 13%</span><span>${totales.iva.toFixed(2)}</span></div>
              <div style={S.totalFinal}><span>TOTAL</span><span>${totales.total.toFixed(2)}</span></div>
              <div style={S.totalRow}><span style={{ color:'#6c757d' }}>Seguro</span><span style={{ color:'#1D9E75' }}>- ${seguro.toFixed(2)}</span></div>
              <div style={{ ...S.totalRow,fontWeight:'700',fontSize:'15px',color:'#dc3545',marginBottom:'16px' }}>
                <span>Copago</span><span>${copago.toFixed(2)}</span>
              </div>
              <button
                style={{ ...S.btnPrimario,width:'100%',padding:'12px',fontSize:'14px',
                  ...(admision.estado_cuenta!=='Cerrada' ? { background:'#c0ccda', cursor:'not-allowed' } : {}) }}
                onClick={emitirFactura}
                disabled={emitiendo || admision.estado_cuenta!=='Cerrada'}
                title={admision.estado_cuenta!=='Cerrada' ? 'Cierra la cuenta primero desde "Cuenta del paciente"' : ''}>
                {emitiendo?'Emitiendo...': admision.estado_cuenta!=='Cerrada' ? '🔒 Cierra la cuenta primero' : '✓ Emitir factura'}
              </button>
            </div>
          </div>
        </>
      )}
      </div>
    </div>
  );
}
